/**
 * Presenting mode (founder: "Bob can share the CR page with nothing internal
 * on it").
 *
 * When on, the surfaces a screen is shared from hide what is ours alone: the
 * AI build cost and AI dev time of a change, its margin and internal cost, a
 * meeting's AI cost, the portfolio's AI spend. The change-order price and the
 * hours stay: that is what the client is shown.
 *
 * Client-side only, and NOT a security boundary: the server still decides
 * what a client account may see. This is for the person sharing their own
 * screen. Persisted in localStorage so a reload mid-meeting keeps it on.
 */
import { create } from "zustand";
import { persist } from "zustand/middleware";

interface PresentingState {
  presenting: boolean;
  setPresenting: (presenting: boolean) => void;
  toggle: () => void;
}

export const usePresenting = create<PresentingState>()(
  persist(
    (set, get) => ({
      presenting: false,
      setPresenting: (presenting) => set({ presenting }),
      toggle: () => set({ presenting: !get().presenting }),
    }),
    { name: "ftl-presenting" },
  ),
);
